import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function InvoicePrintPage() {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user || !invoiceId) {
      setLoading(false);
      setError('Gerekli bilgiler eksik veya giriş yapılmamış.');
      return;
    }

    fetch(`https://www.kenan.bybello.com/backend/api/invoice_print_detail.php?invoice_id=${invoiceId}`)
      .then(res => {
        if (!res.ok) {
          throw new Error('İrsaliye detayları çekilemedi.');
        }
        return res.json();
      })
      .then(data => {
        setInvoiceData(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("İrsaliye detayları çekilirken hata:", err);
        setError(err.message);
        setLoading(false);
      });
  }, [invoiceId, user]);

  const handlePrint = () => {
    // Butonları yazdırmadan gizle
    const buttons = document.querySelectorAll('.no-print');
    buttons.forEach(button => button.style.display = 'none');

    window.print();

    // Yazdırma sonrası butonları tekrar göster
    buttons.forEach(button => button.style.display = 'block');
  };

  const handleClose = () => {
    navigate(-1); // Bir önceki sayfaya geri dön
  };

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  if (loading) return <div className="container mt-4">Yükleniyor...</div>;
  if (error) return <div className="container mt-4 alert alert-danger">{error}</div>;
  if (!invoiceData || !invoiceData.invoice || !invoiceData.customer) return <div className="container mt-4 alert alert-warning">İrsaliye bilgisi bulunamadı.</div>;

  const { invoice, customer, company_name, previous_balance, new_invoice_amount, total_customer_balance, items } = invoiceData;

  return (
    <div className="container" style={{ fontFamily: 'DejaVu Sans, sans-serif', margin: '20px auto', maxWidth: '800px', padding: '20px', border: '1px solid #ccc' }}>
      <style>
        {`
          @media print {
            .no-print { display: none; }
          }
        `}
      </style>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
      <p style={{ float: 'left', margin: 0 }}>İrsaliye</p>
        <h2 style={{ display: 'inline-block', margin: 0 }}> {company_name || 'Şirketim'}</h2>
        <p style={{ float: 'right', margin: 0 }}>Tarih: {invoice.date}</p>
        <div style={{ clear: 'both' }}></div>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <p style={{ display: 'inline-block', margin: 0 }}>Müşteri: SN. {customer.name}</p>
        <p style={{ float: 'right', margin: 0 }}>İrsaliye No: {invoice.invoice_number}</p>
        <div style={{ clear: 'both' }}></div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Ürün Adı</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Açıklama</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Adet</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Birim Fiyat</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Toplam Tutar</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.product_name}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.description || '-'}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{parseInt(item.quantity, 10)}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>₺ {parseFloat(item.unit_price).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>₺ {parseFloat(item.quantity * item.unit_price).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ textAlign: 'left', marginTop: '20px' }}>
        <p>Önceki Bakiye: {parseFloat(previous_balance).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</p>
        <p>Yeni Kesilen İrsaliye Tutarı: {parseFloat(new_invoice_amount).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</p>
        <p>Toplam Müşteri Bakiyesi: {parseFloat(total_customer_balance).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</p>
      </div>

      <div className="no-print" style={{ marginTop: '20px' }}>
        <button onClick={handlePrint} className="btn btn-primary me-2">Yazdır</button>
        <button onClick={handleClose} className="btn btn-secondary me-2">Kapat</button>
        <button onClick={handleGoHome} className="btn btn-dark">Ana Sayfaya Dön</button>
      </div>
    </div>
  );
}

export default InvoicePrintPage; 